const configs = {
  optionsLoader: {
    color: '#2A74F2',
    backgroundColor: '#f3f4f5',
    width: 70,
    height: 70,
    loader: 'spinner',
    zIndex: 9999
  }
}

export default configs
